import React, { useCallback, useEffect, useRef, useState } from 'react'; 
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import FileSaver from 'file-saver';
import * as Yup from 'yup';

import { ReactComponent as CleanIcon } from '../../../../assets/icons/ubr_clean.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/ubr_download.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/ubr_filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Pagination,
  Select,
  Shimmer,
} from '../../../../components';
import api from '../../../../services/api';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { statusOptions } from './status';
import {
  ActionsForm,
  Badge,
  Container,
  FooterTable,
  InputGroup,
  LoadingData,
  OrderContainer,
  TableContainer,
} from './styles';

export enum StatusType {
  Default = 'DEFAULT',
  Pendente = 'PENDENTE',
  Processando = 'PROCESSANDO',
  Sucesso = 'SUCESSO',
  Erro = 'ERRO',
}

interface SearchProps {
  cooperativa: string | undefined;
  conta: string | undefined;
  agencia: string | undefined;
  status: StatusType | undefined;
}

const RelatorioSintetico: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(5);
  const [order, setOrder] = useState<boolean>();
  const formRef = useRef<FormHandles | null>(null);
  const homologData = useRef<any>();
  let selectedStatus = useRef<any>();

  const [filter, setFilter] = useState<any>({
    agencia: null,
    conta: null,
    cooperativa: null,
    paginacao: {
      direcao: !order ? 'ASC' : 'DESC',
      numeroPagina: 0,
      tamanhoPagina: itemsPerPage,
    },
    produto: 'COBRANCA',
    status: null,
  });

  function formatDate(data: string) {
    if (!data) {
      return 'N/D';
    }
    let dateLocal = new Date(data);
    return (
      dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString()
    );
  }

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '160px' }}>
                <OrderContainer>
                  Cooperativa
                  {order ? (
                    <button onClick={() => setOrder(false)}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => setOrder(true)}>
                      <AiOutlineArrowDown />
                    </button>
                  )}
                </OrderContainer>
              </th>
              <th style={{ width: '140px' }}>Agência</th>
              <th style={{ width: '140px' }}>Conta</th>

              <th style={{ width: '140px' }}>
                Data do Primeiro Login cooperado
              </th>
              <th style={{ width: '140px' }}>Data do Inicio da Operação</th>
              <th style={{ width: '140px' }}>Ultima Data Operação</th>
              <th style={{ width: '140px' }}>Data da Ultima Homologação</th>
              <th style={{ width: '140px' }}>Ultimo Status do Processo</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data.content!?.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data!?.content!?.map((todo: any, index: number) => (
                <tr key={index}>
                  <td data-column="Cooperativa">{todo.cooperativa}</td>
                  <td data-column="Agencia">{todo.agencia}</td>
                  <td data-column="Conta">{todo.conta}</td>

                  <td data-column="Data do Primeiro Login cooperado">
                    {formatDate(todo.dataLogin)}
                  </td>
                  <td data-column="Data do inicio da Operação">
                    {formatDate(todo.dataPrimeiraOperacao)}
                  </td>
                  <td data-column="Ultima Data da Operação">
                    {formatDate(todo.dataUltimaOperacao)}
                  </td>
                  <td data-column="Data da Ultima Homologação">
                    {formatDate(todo.dataUltimaHomologacao)}
                  </td>
                  <td data-column="Ultimo Status do Processo">
                    <Badge type={todo.status}>
                      {todo.status ? todo.status : 'N/D'}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  // Data

  const fetchData = useCallback(
    async (search: any) => {
      formRef.current?.setErrors({});
      setIsLoading(true);

      try {
        const response = await api.post('/relatorios/sintetico', search);
        setData(response.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    },
    [filter, itemsPerPage, currentPage, order],
  );

  const handleFilter = useCallback(
    async (dataFilter: SearchProps) => {
      let filteredData: any = homologData.current;

      try {
        formRef.current?.setErrors({});

        if (dataFilter.status) {
          filteredData = filteredData.filter(
            (item: any) => item.status === dataFilter.status,
          );
        }
        if (dataFilter.agencia) {
          filteredData = filteredData.filter(
            (item: any) => item.agencia === dataFilter.agencia,
          );
        }
        if (dataFilter.cooperativa) {
          filteredData = filteredData.filter(
            (item: any) => item.cooperativa === dataFilter.cooperativa,
          );
        }
        if (dataFilter.conta) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          filteredData = filteredData!?.filter(
            (item: any) => item.conta === dataFilter.conta,
          );
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        }
      }

      setFilter({
        cooperativa: dataFilter.cooperativa ? dataFilter.cooperativa : null,
        agencia: dataFilter.agencia ? dataFilter.agencia : null,
        conta: dataFilter.conta ? dataFilter.conta : null,
        status: dataFilter.status ? dataFilter.status : null,
        paginacao: {
          direcao: !order ? 'ASC' : 'DESC',
          numeroPagina: 0,
          tamanhoPagina: itemsPerPage,
        },
        produto: 'COBRANCA',
      });

      fetchData({
        cooperativa: dataFilter!?.cooperativa!
          ? dataFilter!?.cooperativa!
          : null,
        agencia: dataFilter!?.agencia! ? dataFilter!?.agencia! : null,
        conta: dataFilter!?.conta! ? dataFilter!?.conta! : null,
        status: dataFilter!?.status! ? dataFilter!?.status : null,
        paginacao: {
          direcao: !order ? 'ASC' : 'DESC',
          numeroPagina: 0,
          tamanhoPagina: itemsPerPage,
        },
        produto: 'COBRANCA',
      });
    },
    [filter],
  );

  const relatorioDownload = async() => {
    const response = await api.post('relatorios/sintetico/completo', filter,  {
      responseType: 'arraybuffer'
    })

    const url = URL.createObjectURL(
      new Blob (["\ufeff", response!?.data!], {
        type: 'text/csv;charset=utf-8'
      })
    )

    FileSaver.saveAs(
      url, `Relatório-Sintético_${new Date().getTime()}.csv`
    )
  };

  const onClear = () => {
    formRef.current?.reset();

    const select = formRef!.current!.getFieldRef('status');
    select.select.clearValue();

    fetchData({
      cooperativa: null,
      agencia: null,
      conta: null,
      status: null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'COBRANCA',
    });
  };

  useEffect(() => {
    fetchData({
      cooperativa: filter.cooperativa ? filter.cooperativa : null,
      agencia: filter.agencia ? filter.agencia : null,
      conta: filter.conta ? filter.conta : null,
      status: filter.status ? filter.status : null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: currentPage ? currentPage : 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'COBRANCA',
    });
  }, [currentPage, itemsPerPage, order]);

  return (
    <Container>
      <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
        <FilterIcon width={28} />
        <InputGroup>
          <Input
            name="cooperativa"
            label="Cooperativa"
            type="text"
            mask={'coop'}
            placeholder="Ex.: 0000"
          />
          <Input
            name="agencia"
            label="Agencia"
            type="text"
            mask={'coop'}
            placeholder="Ex.: 0000"
          />
          <Input
            name="conta"
            label="Conta"
            type="text"
            mask={'conta'}
            placeholder="Ex.: 00000-0"
          />

          <div className="select-field">
            <Select
              name={'status'}
              isMulti={false}
              options={statusOptions}
              onChange={option => (selectedStatus.current = option.value)}
              placeholder="Selecione"
              label="Status"
              loading={!statusOptions.length ? true : false}
            />
          </div>
        </InputGroup>
        <ActionsForm>
          <div>
            <Button
              variant="solid-icon"
              type={'submit'}
              style={{ marginRight: '1rem' }}
              tooltipText={'Pesquisar'}
            >
              <SearchIcon style={{ width: '26px' }} />
            </Button>
            <Button
              variant="solid-icon"
              type={'reset'}
              onClick={onClear}
              tooltipText={'Limpar Campos'}
            >
              <CleanIcon style={{ width: '26px' }} />
            </Button>
          </div>
        <Button
          variant="solid-icon"
          style={{ width: '24px' }}
            tooltipText={'Baixar Relatório'}
          onClick={() => relatorioDownload()}
        >    
          <DownloadIcon/>
        </Button>
        </ActionsForm>
      </Form>
      {renderData()}
      <FooterTable>
        <Pagination
          pageCount={data.totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={data.pageSize}
          forcePage={currentPage}
          onPageChange={(pageNumber: { selected: number }) => {
            setCurrentPage(pageNumber.selected);
          }}
          onPageSize={(pageSize: any) => {
            setCurrentPage(0);
            setItemsPerPage(pageSize.value);
          }}
        />
      </FooterTable>
    </Container>
  );
};

export default RelatorioSintetico;
